/**
 * Phone formatting – aligns with Angular `mobileValidator` (digit strip + NANP groups).
 * After strip: optional 1–2 digit country prefix + 10 NANP digits (total 10–12).
 */
import { PROPERTY_PHONE_MAX_DIGITS, PROPERTY_PHONE_DIGITS_REGEX } from '../constants'

export {
  PROPERTY_PHONE_MAX_DIGITS,
  PROPERTY_PHONE_DIGITS_REGEX,
  PROPERTY_PHONE_INPUT_MAX_LENGTH,
} from '../constants'

export function digitsOnlyPhone(value: string | undefined | null): string {
  return String(value ?? '').replace(/\D/g, '')
}

export function isValidPropertyPhoneDigits(digits: string): boolean {
  const d = digitsOnlyPhone(digits)
  if (d.length < 10 || d.length > PROPERTY_PHONE_MAX_DIGITS) return false
  return PROPERTY_PHONE_DIGITS_REGEX.test(d)
}

export function isValidOptionalPropertyPhoneDigits(digits: string): boolean {
  const d = digitsOnlyPhone(digits)
  if (d.length === 0) return true
  return isValidPropertyPhoneDigits(d)
}

/**
 * Display format for stored / API values (full digits).
 */
export function formatPhoneDisplay(raw: string | undefined | null): string {
  const d = digitsOnlyPhone(raw).slice(0, PROPERTY_PHONE_MAX_DIGITS)
  if (!d) return ''
  if (d.length <= 10) {
    if (d.length < 10) return maskPhoneOnChange(d)
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
  }
  const body = d.slice(-10)
  const prefix = d.slice(0, -10)
  return `+${prefix} (${body.slice(0, 3)}) ${body.slice(3, 6)}-${body.slice(6)}`
}

/**
 * As-you-type mask: caps at 12 digits; 10 or fewer uses (XXX) XXX-XXXX;
 * 11–12 uses +prefix (XXX) XXX-XXXX (prefix = leading digits before last 10 NANP digits).
 */
export function maskPhoneOnChange(value: string): string {
  const d = digitsOnlyPhone(value).slice(0, PROPERTY_PHONE_MAX_DIGITS)
  if (d.length === 0) return ''
  if (d.length <= 10) {
    if (d.length <= 3) return `(${d}`
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
  }
  const body = d.slice(-10)
  const prefix = d.slice(0, -10)
  return `+${prefix} (${body.slice(0, 3)}) ${body.slice(3, 6)}-${body.slice(6)}`
}
